import React, { useState } from 'react';
import CustomButton from '../../../components/CustomButton/CustomButton';
import Modal from 'react-modal';
import StepOne_ClientSelector from './StepOne_ClientSelector/StepOne_ClientSelector';
import StepTwo_ClassSelector from './StepTwo_ClassSelector/StepTwo_ClassSelector';
import StepTree_Summary from './StepTree_Summary/StepTree_Summary';

const MoveClientsBetweenClasses = ({ isAdmin = false, currentClass = null }) => {
  const [showModal, setShowModal] = useState(false);
  const [step, setStep] = useState(0);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);

  const handleCloseModal = () => {
    setShowModal(false);
    setStep(0);
    setSelectedClient(null);
    setSelectedClass(null);
  };
  const handleOpenModal = () => {
    setShowModal(true);
  };

  if (isAdmin) {
    const handleModalContent = () => {
      if (step === 2) {
        return (
          <StepTwo_ClassSelector
            currentClass={currentClass}
            selectedClient={selectedClient}
            nextStep={setStep}
            onSelect={setSelectedClass}
          />
        );
      }
      if (step === 3) {
        return (
          <StepTree_Summary
            currentClass={currentClass}
            selectedClient={selectedClient}
            selectedClass={selectedClass}
            onCloseModal={handleCloseModal}
          />
        );
      }
      return (
        <StepOne_ClientSelector
          onSelect={setSelectedClient}
          attendanceList={currentClass.attendanceList}
          nextStep={setStep}
          onCloseModal={handleCloseModal}
        />
      );
    };

    return (
      <>
        <Modal
          onRequestClose={handleCloseModal}
          isOpen={showModal}
          className="ss-modal ss-modal--auto"
          ariaHideApp={false}>
          <div className="grommet" style={{ padding: '0 10px' }}>
            {handleModalContent()}
          </div>
        </Modal>
        <CustomButton fullWidth secondary label="Move clients" onClick={handleOpenModal} />
      </>
    );
  }
  return null;
};

export default MoveClientsBetweenClasses;
